import { useCallback } from 'react';
import { useRouter } from 'shared-routing';
import type { JourneyPickerSearchParams } from 'voyager';

import { parseDateToString } from '@utils/helpers';

export function useSpaSearchComplete() {
  const router = useRouter();

  return useCallback(
    (params: JourneyPickerSearchParams) => {
      router.push(
        {
          pathname: router.pathname,
          query: {
            ...router.query,
            arrivalDate: parseDateToString(params.fromDate),
            guests: String(params.adults),
          },
        },
        undefined,
        { shallow: true }
      );
    },
    [router]
  );
}
